import { createApp } from 'vue';
import './assets/main.css';
import App from './App.vue';
import Toast from 'vue-toastification';
import { toast, toastOptions } from '@/plugins/toast'  // <--- nuevo
import 'vue-toastification/dist/index.css';
import PermissionDirective from './v-permission';
import router from './router';
import store from './store';
import VueKonva from 'vue-konva';
import permissionsPlugin from './plugins/permissions';

const app = createApp(App);

// Directiva antigua v-permission (la vamos a enganchar al plugin abajo)
app.directive('permission', PermissionDirective);

// Vuex, router, otros plugins
app.use(store);
app.use(router);
app.use(VueKonva);

// Toast global
app.use(Toast, {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
});

  // Plugin oficial (para componentes que usen useToast(), etc.)
  app.use(Toast, toastOptions);

  // Exposición global (Options API: this.$toast)
app.config.globalProperties.$toast = toast;

  // Provide/inject (Composition API: inject('toast'))
app.provide('toast', toast);

// Plugin de permisos (pasa el store para que pueda llamar a /api/verify-role)
app.use(permissionsPlugin, { store });

app.mount('#app');
